import BaseClass from "../BaseClass.js";

export default class StoriesAvatarScroll extends BaseClass {
    constructor(element) {
        super(element);

        this.$carouselContainer = null;
        this.$carousel = null;
        this.$nextButton = null;
        this.$prevButton = null;

        this.items = this.$element.find('[data-type="carousel-item"]');
        this.itemWidth = this.items.first().outerWidth(true);
        this.currentIndex = 0;

        this.clickNextListener = null;
        this.clickPrevListener = null;
        this.resizeListener = null;

        this.init();
    }

    createListener() {

        let mySelf = this;

        this.clickNextListener = function (event) {
            mySelf.next();
        }
        this.clickPrevListener = function (event) {
            mySelf.prev();
        }
        this.resizeListener = function (event) {
            mySelf.moveCarousel();
        }

    }

    init() {

        this.createListener();

        const $carouselContainer = this.$element.find('[data-type="carousel-container"]');
        if ($carouselContainer != undefined) {
            this.$carouselContainer = $carouselContainer;
        }

        const $carousel = this.$element.find('[data-type="carousel"]');
        if ($carousel != undefined) {
            this.$carousel = $carousel;
        }

        const $nextButton = this.$element.find('[data-type="carousel-btn-next"]');
        if ($nextButton != undefined) {
            this.$nextButton = $nextButton;
            this.$nextButton.on("click", this.clickNextListener);
        }

        const $prevButton = this.$element.find('[data-type="carousel-btn-prev"]');
        if ($prevButton != undefined) {
            this.$prevButton = $prevButton;
            this.$prevButton.on("click", this.clickPrevListener);
        }

        $(document).on("content:resized", this.resizeListener);
    }

    updateVisibleItems() {
        return Math.floor(this.$carouselContainer.outerWidth() / this.itemWidth);
    }

    moveCarousel() {
        const maxIndex = Math.max(0, this.items.length - this.updateVisibleItems());
        if (this.currentIndex > maxIndex) {
            this.currentIndex = maxIndex;
        }
        this.$carousel.css("transform", `translateX(-${this.currentIndex * this.itemWidth}px)`);
    }

    next() {
        if (this.currentIndex < this.items.length - this.updateVisibleItems()) {
            this.currentIndex++;
        }
        this.moveCarousel();
    }

    prev() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
        }
        this.moveCarousel();
    }


    destroyListener() {

        super.destroyListener();

        this.$nextButton.off("click", this.clickNextListener);
        this.$prevButton.off("click", this.clickPrevListener);
        $(document).on("content:resized", this.resizeListener);
    }
}